import React from "react";
import {IconApple, IconFacebook, IconGoogle, IconMicrosoft, IconClever, IconProps, IconClasslink} from "../icons/sso";
import {IconEmail} from "../icons/icons";
import {AuthProviderType} from "../../domain/providers";

const providerIcons: { [key in AuthProviderType]: React.FC } = {
  [AuthProviderType.Google]: IconGoogle,
  [AuthProviderType.Facebook]: IconFacebook,
  [AuthProviderType.Microsoft]: IconMicrosoft,
  [AuthProviderType.Apple]: IconApple,
  [AuthProviderType.Clever]: IconClever, // see docs/002-custom-providers.md
  [AuthProviderType.ClassLink]: IconClasslink,
  [AuthProviderType.Password]: IconEmail
}

export const toProviderIcon = (provider: AuthProviderType): React.ReactElement => {
  const Component = providerIcons[provider];
  return <Component />
}

export const toProviderIconComponent = (provider: AuthProviderType): React.FC<IconProps> => {
  return providerIcons[provider];
}
